export default __webpack_public_path__ + "static/media/chevron-left-active.00cf85de.svg";